import { ENV } from '@/constants';

export const ONBOARDING_API_DOMAINS = {
	CREATE_USER: `${ENV.API_LIFT_STORY_URL}/user`,
	CREATE_ANONYMOUS_USER: `${ENV.API_LIFT_STORY_URL}/anonymous-user`,
	EMAIL_SUBSCRIPTION: `${ENV.API_LIFT_STORY_URL}/user/email-subscription`,
	SOLID_MERCHANT_DATA: `${ENV.API_URL}/solid/form/merchant-data`,
	SOLID_MERCHANT_DATA_V2: `${ENV.API_URL}/v2/solid/form/merchant-data`,
	SOLID_MERCHANT_DATA_V3: `${ENV.API_URL}/v3/solid/form/merchant-data`,
	SOLID_MERCHANT_DATA_V4: `${ENV.API_URL}/v4/solid/form/merchant-data`,
	ONE_CLICK_PAY: `${ENV.API_URL}/solid/one-click-pay`,
	ONE_CLICK_PAY_V3: `${ENV.API_URL}/v3/solid/one-click-pay`,
	SOLID_PAYMENT_PAGE: `${ENV.API_URL}/solid/payment-page/generate`,
	SMM_CONSULTANT_TASK: `${ENV.API_LIFT_STORY_URL}/v3/smm-consultant/tasks`,
	SMM_CONSULTANT_TASK_v4: `${ENV.API_LIFT_STORY_URL}/v4/smm-consultant/tasks`,
	SIGN_UP_BY_APPLE: `${ENV.API_LIFT_STORY_URL}/sign-up/apple`,
	GET_SPLIT_TESTS: `${ENV.API_LIFT_STORY_URL}/web-app/split-tests`,
	CONTENT_PLAN: `${ENV.API_LIFT_STORY_URL}/v1/content-plan`,
};
